module.exports = __webpack_public_path__ + "static/img/product_one.17424a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_one.png
// module id = Rb5m
// module chunks = 1